import React from 'react'

import { ButtonClean } from '@fourthwall/components'

import { routing } from '../../../../../../../../utils/routing'

export const DiscountInfoFields = () => (
  <div style={{ marginTop: 16 }}>
    In order to activate this perk, you must{' '}
    <ButtonClean
      label="create a shop promo for members"
      href={routing.promotions.promotionCodes.create.self}
      target="_blank"
    />
    inside Promotions tab.
  </div>
)
